import { ReactNode } from 'react';
import Image from 'next/image';
import { cn, customImageLoader, getAssetSrc } from '@restworld/utils-common';

function ShowcaseItem({ ctaEl, content, image }: ShowcaseItemProps) {
  return (
    <Wrapper>
      <Image width={128} height={128} alt="" src={getAssetSrc(image)} loader={customImageLoader} />
      {ctaEl}
      <p className="max-w-[200px] text-center text-base font-medium">{content}</p>
    </Wrapper>
  );
}
export default ShowcaseItem;

interface ShowcaseItemProps {
  image: string;
  content: string;
  ctaEl: ReactNode;
}

const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-5 w-fit items-center mx-auto', className)} {...props} />
);
